/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Components
import Badge from 'shared/ui/components/Badge.vue';
import Convert from 'ui/components/webinars/modals/Convert.vue';
import CreateWorkspaceButton from 'ui/components/CreateWorkspaceButton.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';

// Utils
import { isEmpty, clone } from 'lodash';

/**
 * This component is the main Webinars list page controller.
 *
 * @category ui.pages
 * @exports WebinarsList
 * @component
 */
const __vue_script__ = {
    name: 'WebinarsList',

    components: { CreateWorkspaceButton, SearchBar, Badge },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            webinars: {},
            visibleWebinars: {},
            currentStage: 'all',
            searchTerm: '',
            loading: true,
            canCreate: false,
            hasWebinars: false,
            stageClasses: {
                future: ['info'],
                live: ['success'],
                past: ['warn']
            },
            gettingStartedUrl: this.$utils.links.getLinkUrl('getting_started'),
            error: null
        };
    },

    computed: {
        /**
         * @returns {Boolean}
         */
        hasResults() {
            return this.searchTerm.length > 0;
        }
    },

    watch: {
        searchTerm() {
            this.filterSearch();
        }
    },

    async created() {
        try {
            this.webinars = await this.$services.user.getUserEventsGrouped([], 'webinar');
            this.hasWebinars = this.webinars.all.length > 0;
            this.visibleWebinars = clone(this.webinars);
        } catch (error) {
            console.error('[WebinarsList] An error occurred while loading user webinars');
            this.$services.crashReporting.captureException(error);
            this.error = error;
            this.hasWebinars = false;
        }

        this.canCreate = this.$services.user.canCreateWebinars();

        this.loading = false;
    },

    methods: {
        /**
         * Filter the webinars by the search input
         */
        filterSearch() {
            if (isEmpty(this.searchTerm)) this.resetSearch();
            const locale = this.$i18n.locale;
            const searchTerms = this.searchTerm.toLocaleLowerCase(locale).trim().split(' ');

            this.visibleWebinars[this.currentStage] = this.webinars[this.currentStage].filter(w => {
                const lookupString = (`${w.name}${w.readableStartTime}`).toLocaleLowerCase(locale);
                return searchTerms.every(term => lookupString.includes(term));
            });
        },

        createTemplateFromWebinar(webinar) {
            this.$modal.show(Convert, {
                action: async (newName) => {
                    try {
                        await this.$services.webinar.convertToTemplate(webinar.id, newName);
                        this.$notify({
                            group: 'flashes',
                            text: this.$i18n.t('wizards.create_webinar_template.template_created').toString(),
                            type: 'success',
                            duration: 5000
                        });
                    } catch (error) {
                        console.error('[TemplateConversion] Could not convert webinar to template', error);
                        this.$notify({
                            group: 'flashes',
                            text: this.$i18n.t('wizards.create_template.errors.job_creation_failed').toString(),
                            type: 'error',
                            duration: 5000
                        });
                    }
                } }, {
                clickToClose: false,
                height: 'auto'
            });
        },

        /**
         * Reset the filtered search result to the inital dataset
         */
        resetSearch() {
            this.visibleWebinars[this.currentStage] = this.webinars[this.currentStage];
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{staticClass:"inner-page webinars-listing",attrs:{"status":_vm.loading}},[(!_vm.error)?_c('section',{staticClass:"page-content webinars"},[(_vm.hasWebinars)?_c('div',{staticClass:"search"},[(!_vm.loading && _vm.canCreate)?_c('create-workspace-button',{staticClass:"create",attrs:{"modal-classes":"medium","modal-props":_vm.params,"button-key":"webinars.create_new_webinar","modal-type":"webinar"}}):_vm._e(),_c('search-bar',{attrs:{"results":_vm.hasResults},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}},[_c('div',{staticClass:"btn-group actions"},_vm._l((['all', 'live', 'future', 'past']),function(stage){return _c('button',{staticClass:"btn",class:{ primary: _vm.currentStage === stage },attrs:{"disabled":false},on:{"click":function($event){_vm.currentStage = stage}}},[_vm._v(" "+_vm._s(_vm.$t(("events." + stage))))])}),0)])],1):_vm._e(),(_vm.hasResults || _vm.hasWebinars)?_c('div',{staticClass:"section-list"},[_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('webinars.name')))]),_c('th',[_vm._v(_vm._s(_vm.$t('webinars.start_time')))]),_c('th',[_vm._v(_vm._s(_vm.$t('webinars.registrations')))]),_c('th',[_vm._v(_vm._s(_vm.$t('webinars.attendees')))]),_c('th',[_vm._v(_vm._s(_vm.$t('webinars.status')))]),_c('th')])]),_c('tbody',_vm._l((_vm.visibleWebinars[_vm.currentStage]),function(webinar){return _c('tr',[_c('td',[_c('a',{attrs:{"href":_vm.$services.webinar.getWebinarUrl(webinar),"target":"_blank"}},[_vm._v(_vm._s(webinar.name))])]),_c('td',[_vm._v(_vm._s(webinar.readableStartTime))]),_c('td',[_vm._v(_vm._s(webinar.registered_count))]),_c('td',[_vm._v(_vm._s(webinar.attendees_count))]),_c('td',[_c('badge',{attrs:{"config":{classes: _vm.stageClasses[webinar.current_stage]}}},[_vm._v(_vm._s(_vm.$i18n.t(("events." + (webinar.current_stage)))))])],1),_c('td',{staticClass:"actions"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:(_vm.$t('webinars.convert')),expression:"$t('webinars.convert')",modifiers:{"top":true}}],staticClass:"ic-report",on:{"click":function($event){return _vm.createTemplateFromWebinar(webinar)}}})])])}),0)])])]):_vm._e(),(!_vm.hasWebinars)?_c('div',{staticClass:"no-data"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.$utils.assets.imagePath('workspace-start.svg')),expression:"$utils.assets.imagePath('workspace-start.svg')"}],attrs:{"alt":_vm.$t('events.welcome')}}),_c('h1',{staticClass:"welcome"},[_vm._v(_vm._s(_vm.$t('events.welcome')))]),_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t('webinars.empty')))]),(_vm.canCreate)?_c('create-workspace-button',{attrs:{"modal-classes":"medium","modal-props":_vm.params,"button-key":"webinars.create_new_webinar","modal-type":"webinar"}}):_vm._e(),_c('br'),_c('a',{attrs:{"href":_vm.gettingStartedUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('events.getting_started')))])],1):_vm._e()]):_vm._e(),(_vm.error)?_c('div',{staticClass:"alert alert-error"},[_c('h2',[_vm._v(_vm._s(_vm.$t('general.error_occurred')))]),_c('p',[_vm._v(_vm._s(_vm.error))])]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WebinarsList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__